// extracted by mini-css-extract-plugin
export default {"homeFooterWrapper":"index_homeFooterWrapper_Tr26f"};